import { Box, Flex, Text } from "@100mslive/react-ui";
import React, { useContext } from "react";

import { Image } from "./Image";
import { LiveHodoContext } from "../contexts/LiveHodoContext";
import PlaceholderBg from "../images/first_person.png";
import { useTranslation } from "react-i18next";

export const FirstPersonDisplay = React.memo(() => {
  const { t } = useTranslation();

  const {
    stateCtx: { circleRoomDetail },
  } = useContext(LiveHodoContext);

  return circleRoomDetail?.background ? (
    <Box
      css={{
        display: "flex",
        justifyContent: "center",
        size: "100%",
        p: "$12",
        "@md": {
          p: "$4",
        },
      }}
    >
      <Image
        css={{
          h: "100%",
          w: "auto",
          objectFit: "contain",
          p: "$4",
          boxShadow: "$sm",
          "@md": {
            p: "$1",
          },
        }}
        alt={circleRoomDetail?.name}
        src={circleRoomDetail?.background}
      />
    </Box>
  ) : (
    <Box
      css={{
        position: "relative",
        overflow: "hidden",
        w: "37.5rem",
        maxWidth: "80%",
        h: "100%",
        r: "$3",
        m: "0 auto",
        backgroundImage: `url(${PlaceholderBg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        "@md": {
          w: "100%",
          maxWidth: "unset",
        },
      }}
      data-testid="first_person_img"
    >
      <Flex
        align="center"
        direction="column"
        css={{
          position: "absolute",
          w: "100%",
          top: "33.33%",
          left: 0,
          textAlign: "center",
        }}
      >
        <Text color="white" variant="h4" css={{ "@md": { fontSize: "$md" } }}>
          {t("lbl_welcome_joined")}
        </Text>
        <Text
          color="white"
          variant="h6"
          css={{ mt: "$4", "@md": { fontSize: "$sm" } }}
        >
          {t("lbl_person_first")}
        </Text>
        <Text
          color="white"
          variant="h6"
          css={{ mt: "$2", "@md": { fontSize: "$sm" } }}
        >
          {t("lbl_sit_down")}
        </Text>
      </Flex>
    </Box>
  );
});
